
export const BACKEND_URL = "https://prodapi.infralight.cloud/api"
export const AUTH0_NS = "https://infralight.co"
export const AUTH0_DOMAIN = "auth.infralight.cloud"
export const AUTH0_CLIENT_ID = "k7Ex3nkAFr1GsffQCdTlD9sapCrod0v1"
export const AUTH0_AUDIENCE = "infralight-api"

